"use client";

import type React from "react";
import { useState, useEffect } from "react";
import { FormControl, FormLabel, Text, Input } from "@chakra-ui/react";

interface BackchannelWordsProps {
  value: string[] | null | undefined;
  onChange: (value: string[] | null) => Promise<boolean> | void;
}

export const BackchannelWords: React.FC<BackchannelWordsProps> = ({
  value,
  onChange,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  // Convert array to comma-separated string for the input
  useEffect(() => {
    if (value && Array.isArray(value)) {
      setInputValue(value.join(", "));
    } else {
      setInputValue("");
    }
  }, [value]);

  const handleBlur = async () => {
    const words = inputValue
      .split(",")
      .map((word) => word.trim())
      .filter((word) => word.length > 0);

    const newValue = words.length > 0 ? words : null;

    if (JSON.stringify(newValue) !== JSON.stringify(value)) {
      setIsUpdating(true);
      try {
        await onChange(newValue);
      } finally {
        setIsUpdating(false);
      }
    }
  };

  return (
    <FormControl>
      <FormLabel fontSize="sm" fontWeight="medium" color="secondary.700" mb={1}>
        Backchannel Words
      </FormLabel>

      <Text fontSize="xs" color="gray.600" mb={2}>
        A list of words that the agent would use for backchanneling.
        {/* <Link href="https://docs.retellai.com/build/interaction-configuration" isExternal color="gray.600">
          Learn more <ExternalLinkIcon mx="2px" />
        </Link> */}
      </Text>

      <Input
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onBlur={handleBlur}
        placeholder="Split by comma. Example: yeah, uh-huh, okay"
        size="sm"
        bg="white"
        borderColor="gray.300"
        _hover={{ borderColor: "gray.400" }}
        _focus={{ borderColor: "gray.400", boxShadow: "none" }}
        isDisabled={isUpdating}
      />
    </FormControl>
  );
};
